<div class="card card-tabs">
	<div class="card-body">
		<label for="" class="title-history">
			Asociar Notas de Ingreso
		</label>
		<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
			<input type="radio" name="pcss3t" [appCheckPermission]="[5069]" [permissionType]="permissionType.ALL"
				[(ngModel)]="tab" [value]="0" checked id="tab1">
			<label for="tab1" [appCheckPermission]="[5069]" [permissionType]="permissionType.ALL">
				<i class="fa fa-file-signature"></i>Nota de Entrada → Compra
			</label>

			<!-- <input type="radio" name="pcss3t" [appCheckPermission]="[5047,5017]" [permissionType]="permissionType.ALL"
				[(ngModel)]="tab" [value]="1" checked id="tab2">
			<label for="tab2" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL">
				<i class="bx bxs-check-circle"></i>Nota de Entrada → Orden
			</label> -->

			<input type="radio" name="pcss3t" [appCheckPermission]="[5069]" [permissionType]="permissionType.ALL"
				[(ngModel)]="tab" [value]="2" checked id="tab3">
			<label for="tab3" [appCheckPermission]="[5069]" [permissionType]="permissionType.ALL">
				<i class="fa fa-certificate"></i>Nota de Entrada → COA
			</label>

		</div>
		
		
		<div class="row" [hidden]="tab!=0">
			<div class="col" id="list-container">
				<app-entrynote-purchase-association *ngIf="tab==0"></app-entrynote-purchase-association>
			</div>
		</div>
		<div class="row" [hidden]="tab!=1">
			<div class="col" id="list-container">
				<app-entrynote-order-association *ngIf="tab==1"></app-entrynote-order-association>
			</div>
		</div>
		<div class="row" [hidden]="tab!=2">
			<div class="col" id="list-container">
				<app-association-entry-note-coa *ngIf="tab==2"></app-association-entry-note-coa>
			</div>
		</div>
		<!-- <div class="row" [hidden]="tab!=1">
			<div class="col" id="list-container">
				<app-purchase-association *ngIf="tab==1"></app-purchase-association>
			</div>
		</div> -->
	</div>

</div>